/**
 * Self-heal after a deploy: when a lazily loaded chunk fails (typically a 404
 * because the running page predates the current build), reload once so the
 * browser picks up the new build instead of leaving the user on a broken page.
 * Vite dispatches 'vite:preloadError' on window for exactly this case.
 *
 * A sessionStorage timestamp guards against reload loops when the failure has
 * another cause (e.g. offline): within the guard window the error is left to
 * propagate normally instead of reloading again.
 */
const GUARD_KEY = 'gsx8:preload-error-reloaded-at';
const GUARD_WINDOW_MS = 60_000;

export function installPreloadErrorReload(): void {
  window.addEventListener('vite:preloadError', (event: Event) => {
    const lastReload = Number(sessionStorage.getItem(GUARD_KEY) ?? 0);
    if (Date.now() - lastReload < GUARD_WINDOW_MS) return;
    sessionStorage.setItem(GUARD_KEY, String(Date.now()));
    event.preventDefault();
    window.location.reload();
  });
}
